import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Componentparameters from '../components/componentparameters'
import FooterMain from '../components/footer-main'
import './about-waam.css'

const AboutWAAM = (props) => {
  return (
    <div className="about-waam-container">
      <Helmet>
        <title>
          Что такое WAAM? | Arcobo – 3D-печать металлом
        </title>
        <meta
          name="description"
          content="WAAM (Wire Arc Additive Manufacturing) — технология аддитивного производства крупногабаритных металлических деталей сварочной проволокой. Узнайте, как Arcobo применяет WAAM для 3D-печати металлом."
        />
        <meta
          property="og:title"
          content="Что такое WAAM? | Arcobo – 3D-печать металлом"
        />
        <meta
          property="og:description"
          content="WAAM (Wire Arc Additive Manufacturing) — технология аддитивного производства крупногабаритных металлических деталей сварочной проволокой. Узнайте, как Arcobo применяет WAAM для 3D-печати металлом."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Что такое WAAM? | Arcobo – 3D-печать металлом"
        />
        <meta
          name="twitter:description"
          content="WAAM (Wire Arc Additive Manufacturing) — технология аддитивного производства крупногабаритных металлических деталей сварочной проволокой. Узнайте, как Arcobo применяет WAAM для 3D-печати металлом."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/about-waam"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/about-waam"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Что такое WAAM?","item":"https://arcobo.tech/about-waam"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name28"></HeaderMain>
      <Componenttextimage
        image1Src="/0_Main_page/main_00-1500w.webp"
        image1Alt="Промышленная роботизация Arcobo"
        rootClassName="componenttextimageroot-class-name16"
        textComponent={
          <Fragment>
            <span className="about-waam-text10">
              <span>
                WAAM (Wire Arc Additive Manufacturing) - технология аддитивного
                производства металлических деталей, при которой электрическая
                дуга расплавляет металлическую проволоку, а робот или портальная
                система послойно формирует изделие по 3D-модели.
              </span>
              <br></br>
              <br></br>
              <span>
                В отличие от порошковой 3D-печати, WAAM использует стандартную
                сварочную проволоку и обеспечивает очень высокую скорость
                наплавки. Технология особенно эффективна для производства
                средних и крупногабаритных деталей массой от нескольких
                килограммов до нескольких тонн.
              </span>
              <br></br>
              <br></br>
              <span>
                WAAM объединяет возможности промышленной робототехники, сварки и
                металлургии. Свойства готовой детали определяются не только
                оборудованием, но прежде всего правильным подбором сплава,
                режимов наплавки, теплового цикла и стратегии построения
                изделия.
              </span>
            </span>
          </Fragment>
        }
        componentTitle="Что такое WAAM?"
      ></Componenttextimage>
      <Componentparameters
        text1={
          <Fragment>
            <span className="about-waam-text18">
              WAAM обеспечивает производительность в несколько килограммов
              металла в час, что делает технологию особенно эффективной для
              изготовления средних и крупных деталей.
            </span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="about-waam-text19">
              Рабочая зона определяется кинематикой робота и дополнительными
              осями. WAAM позволяет создавать изделия от небольших заготовок до
              конструкций размером в несколько метров.
            </span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="about-waam-text20">
              В качестве материала используется промышленная сварочная
              проволока. Она широко доступна, удобна в хранении и обычно
              значительно дешевле металлических порошков.
            </span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="about-waam-text21">
              Каждый новый слой наплавляется с проплавлением предыдущего,
              формируя монолитную металлическую структуру. Качество определяется
              металлургией конкретного сплава и правильно подобранным тепловым
              циклом.
            </span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="about-waam-text22">
              Чем больше деталь и выше стоимость исходной заготовки, тем
              заметнее преимущество WAAM перед механической обработкой из
              цельного металла
            </span>
          </Fragment>
        }
        heading1="Самая высокая скорость металлической 3D-печати "
        heading2="Практически нет ограничений по размерам"
        heading3="Доступное сырье"
        heading4="Полное металлургическое сплавление"
        heading5="Экономичность габаритного производства"
        mainHeading="Главные преимущества технологии"
        rootClassName="componentparametersroot-class-name8"
        componentTitle="Что такое WAAM? "
      ></Componentparameters>
      <FooterMain rootClassName="footer-mainroot-class-name27"></FooterMain>
    </div>
  )
}

export default AboutWAAM
